import React from "react";

import { getLabel } from "../../../hooks/use-labels";
import HexButton from "../../../ui-kit/HexButtons";
import ModalTitle from "../../HexModal/ModalTitle";
import "./style.css";
import HexModal from "..";

const ImageModal = ({ open, imageSrc, onCancel, label, title, titleClass }) => {
  return (
    <HexModal open={open} modalClass={"image-modal"}>
      {title && <ModalTitle text={title} className={titleClass || ""} />}
      <img
        src={imageSrc}
        className="image-container mb-4 picture-box-shadow max-full-width"
        alt="imageSrc"
      />
      <HexButton
        type="primary"
        onClick={onCancel}
        label={label || getLabel("okayBtn")}
        width={{ pixels: 100, unit: "%" }}
        className="text-sm mt-16"
      />
    </HexModal>
  );
};

export default ImageModal;
